
<modal
  disable-close-backdrop
  title="Add Cards to Watchlist"
  :open="open"
  @close="closeModal"
>
  <card-search
    placeholder="Search for a card"
    :exclude-ids="cardIds"
    @select="addCard"
  />

  <br />

  <div
    v-for="card in cards"
    :key="card.id"
    class="card-item"
  >
    <align no-gap>
      <icon-button
        icon="close"
        @click="removeCard(card.cardId)"
      />

      <card-list-item :card="card" :fields="['currentValue']" />
    </align>
  </div>

  <div class="action">
    <btn
      loading-text="Adding"
      :loading="saving"
      :disabled="disabled"
      @click="submit"
    >
      Add to Watchlist
    </btn>
  </div>
</modal>
